import { Component, Input, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Catalog } from '@app/core/business/catalog/catalog';
import { Product } from '@app/core/business/product/product';
import { ContextService } from '@app/core/service/context.service';
import { environment } from '@env/environment';
import { BehaviorSubject, interval, timer } from 'rxjs';
declare var jQuery: any;

@Component({
  selector: 'app-catalog',
  templateUrl: './catalog.component.html',
  styleUrls: ['./catalog.component.scss'],
})
export class CatalogComponent implements OnInit, OnDestroy {
  @Input()
  catalog: Catalog;
  @Input()
  availabilities$: BehaviorSubject<any>;

  @ViewChild('carousel', { static: true })
  carousel: ElementRef<any>;

  public owl: any;
  public show = false;
  public updating = false;
  public environment = environment;
  public search: string;

  constructor(public contextService: ContextService) { }

  ngOnInit() {

  }
  trackByProduct(index: number, product: Product) {
    return product.code;
  }
  ngAfterViewInit() {

      this.owl = jQuery(this.carousel.nativeElement).owlCarousel({
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        loop: false,
        rewind: true,
        margin: 15,
        singleItem: true,
        dots: false,
        responsive: {
          0: {
            items: 1,
            slideBy: 1,
          },
          650: {
            items: 2,
            slideBy: 1,
          },
          990: {
            items: 3,
            slideBy: 1,
          },
          1420: {
            items: 4,
            slideBy: 1,
          },
          1800: {
            items: 5,
            slideBy: 1,
          },
        },
    });

    // On définit les boutons "Voir plus"
    if (this.contextService.fullContext?.company?.code == 'VITAFRAIS') {
      if (this.catalog.label.toUpperCase().includes('AUTRES ARTICLES DE LA MÊME MARQUE'))
        this.catalog.searchWord = "search/" + this.catalog.products[0].brand;
      else if (this.catalog.label.toUpperCase().includes('AUTRES ARTICLES :'))
        this.catalog.searchWord = "search/" + this.catalog.label.slice(('AUTRES ARTICLES : ').length);
      else if (this.catalog.label.toUpperCase().includes('Mon cadencier'.toUpperCase()))
        this.catalog.searchWord = "mode/schedulers";
      else if (this.catalog.label.toUpperCase().includes('Les promo\' du moment'.toUpperCase()))
        this.catalog.searchWord = "discount";
      else if (this.catalog.label.toUpperCase().includes('Nos derniers lancements'.toUpperCase()))
        this.catalog.searchWord = "new";
      else if (this.catalog.label.toUpperCase().includes('Les produits Anti-Gaspi'.toUpperCase()))
        this.catalog.searchWord = "AntiGaspi";
      else
        this.catalog.searchWord = "GEN";
    } else if (this.contextService.fullContext?.company?.code == 'PRONATURAFRANCE') {
      if (this.catalog.label.toUpperCase().includes('Les promo\' du moment'.toUpperCase()))
        this.catalog.searchWord = "discount";
      else if (this.catalog.label.toUpperCase().includes('C\'est nouveau à l\'offre'.toUpperCase()))
        this.catalog.searchWord = "new";
      else
        this.catalog.searchWord = "offers";
    }
    else {
      this.catalog.searchWord = "";
    }
  }

  ngOnDestroy() { }

  // Afficher les produits précédents
  public prev() {
    this.owl.trigger('prev.owl.carousel');
  }

  // Afficher les produits suivants
  public next() {
    this.owl.trigger('next.owl.carousel');
  }
}
